export default "__VITE_ASSET__e74cc5a0__"